import {
  ADD_VISITOR_STARTED,
  ADD_VISITOR_COMPLETED,
  ADD_VISITOR_ERROR,
  FETCH_VISITORS_STARTED,
  FETCH_VISITORS_COMPLETED,
  FETCH_VISITORS_ERROR,
  ADD_VISITORDETAIL_STARTED,
  ADD_VISITORDETAIL_COMPLETED,
  UPDATE_VISITOR_STARTED,
  UPDATE_VISITOR_COMPLETED,
  UPDATE_VISITOR_ERROR
} from '../actionTypes/visitorActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  visitors: {},
  visitor: {}
};

function visitorReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_VISITOR_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_VISITOR_COMPLETED: {
      let key = action.payLoad.id;
      let data = action.payLoad.data;
      state.visitors[key] = data;
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_VISITOR_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_VISITORS_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_VISITORS_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          visitors: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_VISITORS_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case ADD_VISITORDETAIL_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_VISITORDETAIL_COMPLETED: {
      return {
        ...state,
        visitor: { ...action.payLoad },
        submitted: false,
        success: true
      };
    }
    case UPDATE_VISITOR_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case UPDATE_VISITOR_COMPLETED: {
      let key = action.payLoad.id;
      let data = action.payLoad.data;
      state.visitors[key].isUser = data.isUser;
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case UPDATE_VISITOR_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    default:
      return state;
  }
}

export default visitorReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/visitors.js